import React from 'react'
import { Link } from 'react-router-dom'
import { Heading, Text } from '@liquidcollectibles/uikit'
import styled from 'styled-components'
import { getCollectionBySymbol } from 'state/collectibles/hooks'
import { NftCollectionApr } from 'state/collectibles/types'
import { useFetchPublicPoolsData, useLicoPoolApr, usePools } from 'state/pools/hooks'
import { getAprData } from 'views/Pools/helpers'
import tokens from 'config/constants/tokens'
import StackingCard from '../StackingCard'

const CollectionGrid = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 1fr;

  ${({ theme }) => theme.mediaQueries.lg} {
    grid-template-columns: repeat(3, 1fr);
  }
`

const HotStacking = ({ account }: { account: string }) => {
  useFetchPublicPoolsData()
  const { pools: poolsWithoutAutoVault } = usePools(account)
  poolsWithoutAutoVault[0].apr = useLicoPoolApr()
  const sorted = poolsWithoutAutoVault?.slice().sort((poolA, poolB) => poolB.apr - poolA.apr)
  const poolsToShow = sorted?.slice(0, 3)

  const collectionsToShow: NftCollectionApr[] = []
  poolsToShow?.map((pool) => {
    const col = getCollectionBySymbol(pool.earningToken.symbol)
    const { apr: aprData } = getAprData(pool, 0)
    const newCol = { ...col, apr: pool.apr ?? aprData }

    collectionsToShow.push(newCol as NftCollectionApr)
    return pool.earningToken
  })

  return (
    <div style={{ display: 'flex', flexDirection: 'column', paddingTop: 64 }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: 'white',
          marginBottom: 32,
        }}
      >
        <Heading scale="lg">Hot Staking</Heading>
        <Link to="/stake">
          <Text color="primary" bold>
            View All
          </Text>
        </Link>
      </div>
      <CollectionGrid>
        {collectionsToShow?.map((col) => (
          <StackingCard collection={col} key={col.nftAddress ?? tokens.lico.address[56]} />
        ))}
      </CollectionGrid>
    </div>
  )
}

export default HotStacking
